import MainProfileActions from 'components/main';
import useLastProgram from 'hooks/useLastProgram';
import { FC, useContext, useEffect } from 'react';
import { PatientContext } from 'state/contexts/patient';
import { ActionTypes as PatientActionTypes } from 'state/reducers/patient';
import { ChartsBox } from './charts-box/patient-chart-box';
import TasksBox from './tasks-box/TasksBox';

type Props = {
  setProfileTabUnreviewed: (unreviewed: boolean) => void;
};

export const ProfileTabComponent: FC<Props> = ({ setProfileTabUnreviewed }) => {
  const { patientState, patientDispatch } = useContext(PatientContext);
  const patient = patientState.current!;

  const currentProgram = useLastProgram();

  useEffect(() => {
    if (!currentProgram) {
      return;
    }

    patientDispatch({ type: PatientActionTypes.SET_PROGRAM, payload: currentProgram });
  }, [currentProgram]);

  return (
    <>
      <ChartsBox key={`chart-${patient.id}`} setProfileTabUnreviewed={setProfileTabUnreviewed} />

      <TasksBox patientId={patient.id} key={`task-${patient.id}`} />

      {/* activate all buttons */}
      <MainProfileActions key={`main-profile-buttons-${patient.id}`} />
    </>
  );
};
